module.exports = __webpack_public_path__ + "static/media/blockchain.87acfeb5.png";